import React, { FC, useContext } from "react";

import { css } from "@emotion/react";
import { getTextColor } from "@intelligems/ig-utils";

import { DiscountProgressBarContext } from "../../context";
import { BreakpointProps } from "../types";

export const CompletedBreakpoint4: FC<BreakpointProps> = () => {
  const { theme } = useContext(DiscountProgressBarContext);
  const circleClass = css`
    fill: ${theme.breakpoint.activeColor};
    stroke: ${theme.breakpoint.activeColor};
  `;

  const pathClass = css`
    fill: ${getTextColor(
      getComputedStyle(document.documentElement).getPropertyValue(
        theme.breakpoint.activeColorKey
      )
    )};
  `;

  return (
    <span className="ig-dp-completed-breakpoint filled">
      <svg width={28} height={28} fill="none" viewBox="0 0 88 88">
        <path
          d="m87.498 43.799-7.488-9.766 1.674-12.134-11.429-4.538-4.532-11.442-12.121 1.676L43.749 0l-9.755 7.497-12.12-1.677-4.533 11.443L5.912 21.8l1.674 12.135L0 43.799l7.488 9.767L5.814 65.7l11.429 4.537 4.532 11.443 12.121-1.677 9.755 7.497 9.755-7.497 12.12 1.677 4.533-11.443 11.429-4.636-1.674-12.134 7.686-9.668h-.002Z"
          css={circleClass}
        />
        <path
          d="m36.458 52.637-9.57-9.571-3.19 3.19 12.76 12.761 27.344-27.344-3.19-3.19-24.154 24.154Z"
          css={pathClass}
        />
      </svg>
    </span>
  );
};
